var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selectable-service-resource',{attrs:{"value":{ valueKeys: _vm.value.items || [] },"resource":_vm.value.resource,"multiple":"","errors":_vm.chipErrors},on:{"select":_vm.onItemSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }